module.exports = __webpack_public_path__ + "img/m_banner.a4b1c0ae.png";